export default "__VITE_ASSET__5$K$W3mx__"